import { produce } from 'immer'
import {
  SET_ORG_EXPENSE_REPORT_DATE_UPDATE_CONFIRMED,
  SetOrgExpenseReportDateUpdateConfirmedAction,
} from 'src/redux/actions/data/orgExpenseReports.actions'

export interface OrgExpenseReportsState {
  dateUpdateRequiresConfirmation: boolean
}

export const initialState: OrgExpenseReportsState = {
  dateUpdateRequiresConfirmation: false,
}

export type Actions = SetOrgExpenseReportDateUpdateConfirmedAction

const OrgExpenseReportsReducer = (
  state: OrgExpenseReportsState = initialState,
  action: Actions,
): OrgExpenseReportsState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case SET_ORG_EXPENSE_REPORT_DATE_UPDATE_CONFIRMED: {
        draft.dateUpdateRequiresConfirmation = action.payload
        return draft
      }
    }
  })
}

export default OrgExpenseReportsReducer
